import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "table-cell-content"
}

import { UnmanagedBusinessContentViewModel } from './unmanagedBusinessTableContentViewModel';
import { TableContentProperty, UnmanagedBusinessHeaderKey } from '../../interface/tableContentHeaders';
import TableCell from '../TableCell.vue';
import { TableContentItem } from '../../interface/tableContentItems';
import { i18n } from '@/i18n';
import RegisterUnmanagedBusinessButton from './RegisterUnmanagedBusinessButton.vue';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UnmanagedBusinessTableCell',
  props: {
    header: {},
    unmangedBusinessHeaderKey: {},
    item: {},
    headerIndex: {},
    accumulationTableContentWidth: {},
    isVariableWidth: { type: Boolean },
    isAllSelected: { type: Boolean },
    stableColumnCount: {},
    isEditing: { type: Boolean },
    isBold: { type: Boolean },
    isChecked: { type: Boolean },
    isCheckedBusinessId: { type: Boolean }
  },
  emits: ["onClickNarrow"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

// props
const props = __props;

// emits
const emits = __emit;

const unmanagedBusinessContentViewModel = new UnmanagedBusinessContentViewModel();

const textAlign = computed(() => {
  return props.header.propertyPath?.propertyType === 'number' ? 'right' : 'left';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableCell, {
    class: _normalizeClass([[_unref(unmanagedBusinessContentViewModel).isSticky(_ctx.stableColumnCount, _ctx.headerIndex) ? 'sticky-content' : ''], "table-cell base-table__body--fixed"]),
    style: _normalizeStyle({
      left: _unref(unmanagedBusinessContentViewModel).calcStickyDiff(_ctx.stableColumnCount, _ctx.headerIndex, _ctx.accumulationTableContentWidth),
    }),
    "text-align": textAlign.value,
    "table-content-property": _ctx.header,
    "tool-tip-value": _unref(unmanagedBusinessContentViewModel).displayOrderItem(_ctx.unmangedBusinessHeaderKey, _ctx.item),
    "is-highlighted": props.isChecked || props.isCheckedBusinessId
  }, {
    default: _withCtx(() => [
      (_ctx.header.key === 'registerBusiness')
        ? (_openBlock(), _createBlock(RegisterUnmanagedBusinessButton, {
            key: 0,
            class: "register-unmanaged-business",
            item: _ctx.item
          }, null, 8, ["item"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(unmanagedBusinessContentViewModel).displayOrderItem(_ctx.unmangedBusinessHeaderKey, _ctx.item)), 1))
    ], undefined, true),
    _: 1
  }, 8, ["class", "style", "text-align", "table-content-property", "tool-tip-value", "is-highlighted"]))
}
}

})